module.exports = __webpack_public_path__ + "img/logo.42270201.png";